import merge from '@bundled-es-modules/deepmerge'
import { createSlice } from '@reduxjs/toolkit'
import { getProperty as getProp, setProperty as setProp } from 'dot-prop'
import session_schema from '~/schemas/session_schema'
import initialState from './initial'

const settingsSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		setSettingsProperty: (s, { payload }) => {
			const [k, v] = payload
			setProp(s, k, v)
		},
		patchSettingsProperty: (s, { payload }) => {
			const [k, v] = payload
			const value = getProp(s, k)
			setProp(s, k, merge(value, v))
		},
	},
	extraReducers: builder => {
		/**
		 * ⚠️ TEMPORARY — delete this once `xl` is fully resolved (machines available AND priced per minute). It exists to stop a stale persisted `xl` reaching the server after `xl` becomes legal again.
		 *
		 * The settings slice persists to localStorage with no expiry, so a browser that last opened while `xl` was the default still holds it — and a client-side legality check cannot help: `xl` stays a legal option throughout, so nothing distinguishes "chose XL deliberately last week" from "inherited XL in 2025". By the time it IS legal again, the distinction is gone forever.
		 *
		 * Resetting on AUTH is what closes that: it is a recurring event, so a user dormant through the whole restricted period is corrected whenever they next return, with no migration that must remember to fire and no version stamp to reason about. Not a migration — a plain assignment, idempotent by nature.
		 *
		 * `auth/setAuth` fires once per PAGE LOAD, not per token refresh (`AuthGuard` gates it on an empty token), so a deliberate XL pick survives for the rest of that session and is cleared on the next load. Stricter than "on login", and deliberately so: the cost is one re-pick, and the guarantee holds for a user who never signs out.
		 *
		 * Applies to admins too, deliberately. One rule with no branch, and an admin who wants XL re-picks it — which is also the only group the server will accept it from.
		 */
		builder.addCase('auth/setAuth', s => {
			s.session_type = session_schema.properties.session_type.initial
		})
	},
})

export const { setSettingsProperty, patchSettingsProperty } = settingsSlice.actions

export default settingsSlice.reducer
